import styled from "styled-components";
import React from "react";

//className="cls-6"
const BackgroundOne = styled.path`
  fill: #dfdfea;
  opacity: 0.92;
  stroke-width: 0;
`;

//className="cls-9"
const BackgroundTwo = styled.path`
  fill: #c1e5e2;
  opacity: 0.75;
  stroke-width: 0;
`;

//className="cls-7"
const BackgroundThree = styled.path`
  fill: #85b6c1;
  opacity: 0.66;
  stroke-width: 0;
`;

export const BackgroundSvgs = ({
  sizeW = "100vw",
  sizeH = "100vh",
  ...props
}) => (
  <svg viewBox="850 500 1950 1244.95" width={sizeW} height={sizeH} {...props}>
    <BackgroundOne d="M2787.25,1241.33c-80.96,235.35-545.47,159.5-606.2,178.52-60.72,19.02-146.18,171.16-470.04,76.07-93.98-27.6-681.12-86.17-849.19,15.67l-7.67-229.62c83.21,23.77,792.11-127.44,886.1-99.84,323.85,95.09,601.19,62.69,661.91,43.67,60.72-19.02,323.14-57.94,383.86-129.25l1.22,144.79Z" />
    ;
    <BackgroundTwo d="M2784.09,1733.33c-33.98-127.08-135.46-205.54-197.1-193.39-308.11,60.78-486.76,234.92-1220.95,74.87-99.94-21.78-427.19,142.97-511.01,115.34v-136.38c83.82,27.63,357.29-246.13,451.96-214.07,326.23,110.51,928.85-33.15,990.02-55.25,61.17-22.1,415.7,50.16,481.4,30.83l5.68,378.05Z" />
    <BackgroundThree d="M863.03,1241.69c83.1,30.2,263.73,125.14,382.67,48.67,317.58-204.21,645.22-10.6,705.86-34.76,60.64-24.16,770.56,25.26,835.7,4.12l-1.94-349.03c-60.64,90.59-344.32,155.71-404.96,179.86-60.64,24.16-316.03,49.64-639.46-71.15-93.86-35.05-801.85,157.03-884.95,126.83l7.09,95.47Z" />
  </svg>
);

export const BackgroundSvgOne = ({
  sizeW = "100vw",
  sizeH = "100vh",
  ...props
}) => (
  <svg viewBox="0 0 1931.3 408.8" width={sizeW} height={sizeH} {...props}>
    <g>
      <BackgroundOne d="M7.1,331c83.1,30.2,263.7,125.1,382.7,48.7,317.6-204.2,645.2-10.6,705.9-34.8,60.6-24.2,770.6,25.3,835.7,4.1l-1.9-349c-60.6,90.6-344.3,155.7-405,179.9-60.6,24.2-316,49.6-639.5-71.2C791.1,73.7,83.1,265.7,0,235.5l7.1,95.5Z" />
    </g>
  </svg>
);

export const BackgroundSvgTwo = ({
  sizeW = "100vw",
  sizeH = "100vh",
  ...props
}) => (
  <svg viewBox="0 0 1933.1 430.4" width={sizeW} height={sizeH} {...props}>
    <g>
      <BackgroundTwo d="M1933.1,144.8c-81,235.3-545.5,159.5-606.2,178.5-60.7,19-146.2,171.2-470,76.1-94-27.6-681.1-86.2-849.2,15.7L0,185.4c83.2,23.8,792.1-127.4,886.1-99.8,323.9,95.1,601.2,62.7,661.9,43.7,60.7-19,323.1-57.9,383.9-129.3l1.2,144.8Z" />
    </g>
  </svg>
);

export const BackgroundSvgThree = ({
  sizeW = "100vw",
  sizeH = "100vh",
  ...props
}) => (
  <svg viewBox="0 0 1929.1 413.1" width={sizeW} height={sizeH} {...props}>
    <g>
      <BackgroundThree d="M1929.1,413.1c-34-127.1-135.5-205.5-197.1-193.4-308.1,60.8-486.8,234.9-1221,74.9C411.1,272.8,83.8,437.6,0,409.9v-136.4C83.8,301.2,357.3,27.4,452,59.5c326.2,110.5,928.9-33.2,990-55.3,61.2-22.1,415.7,50.2,481.4,30.8l5.7,378Z" />
    </g>
  </svg>
);
